import type { DefaultError, UseQueryResult } from '@tanstack/react-query'
import type { RefObject } from 'react'
import { createContext, useContext } from 'react'

import type {
  GetContentModuleResponse,
  GetContentResponse,
  GetSidekicksResponse,
  GetStepsResponse,
} from '@/services/api/api.types'

import type { ContentDataModal } from './ContentDataModal'

export type ModuleContentSection = {
  taskId?: string
  modal: RefObject<ContentDataModal | null>

  cmQuery: UseQueryResult<GetContentModuleResponse, DefaultError>
  cmContentQuery: UseQueryResult<GetContentResponse, DefaultError>
  stepsQuery: UseQueryResult<GetStepsResponse, DefaultError>
  sidekicksQuery: UseQueryResult<GetSidekicksResponse, DefaultError>
  sidekickPoolQuery: UseQueryResult<GetSidekicksResponse | null, DefaultError>
}

export const ModuleContentSectionContext = createContext<ModuleContentSection>({} as ModuleContentSection)
export const useContentModuleScreenData = () => useContext(ModuleContentSectionContext)
